import { useRef } from "react";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const CreateBranchForm = (props: any) => {
  const {
    handleCreate,
    isLoading,
    setError,
    getValues,
    invoiceReport,
    setOrderData,
  } = props;

  const debounceRef = useRef(false);

  const handleGenerateClick = () => {
    if (debounceRef.current) return;
    debounceRef.current = true;
    handleCreate(getValues(), setError);
    setOrderData([]);
    setTimeout(() => {
      debounceRef.current = false;
    }, 2000);
  };

  return (
    <>
      <>
        <div className="flex justify-between mt-8">
          <div>Total Number of order:</div>
          <div>{invoiceReport?.totalOrder}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div>Total Collected COD:</div>
          <div>{invoiceReport?.totalCollectedCod}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div>Commision:</div>
          <div>{invoiceReport?.commission ?? 0}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div> Branch Rate:</div>
          <div>{invoiceReport?.totalBranchCharge}</div>
        </div>

        <div className="flex justify-between mt-2 font-bold">
          <div>Transit Charge</div>
          <div>{invoiceReport?.totalTransitCharge}</div>
        </div>
        <div className="flex justify-between mt-2 font-bold">
          <div>Net Payable</div>
          <div>
            {Number(
              invoiceReport?.totalCollectedCod -
                invoiceReport?.totalBranchCharge
            )}
          </div>
        </div>
        <div className={tw`mx-auto w-full flex justify-end`}>
          <div className={tw`w-40`}>
            <Button
              label={"Generate Statement"}
              isLoading={isLoading}
              onClick={handleGenerateClick}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default CreateBranchForm;
